module.exports = __webpack_public_path__ + "img/korokoro_admin.e0490d69.png";